// useCloseModalsOnBrowserNav.js
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Close all modals when the user uses the browser Back/Forward buttons.
 * Call inside a component once (near the top of your app tree).
 */
export function useCloseModalsOnBrowserNav(closeAll) {
    const location = useLocation();
    const navType = useNavigationType(); // "POP" | "PUSH" | "REPLACE"

    // Close on browser back/forward navigations handled by the router
    useEffect(() => {
        if (navType === "POP") {
            closeAll && closeAll();
        }
    }, [location, navType, closeAll]);

    // Extra safety: catch native popstate/hash changes
    useEffect(() => {
        const onPop = () => closeAll && closeAll();
        window.addEventListener("popstate", onPop);
        window.addEventListener("hashchange", onPop);
        return () => {
            window.removeEventListener("popstate", onPop);
            window.removeEventListener("hashchange", onPop);
        };
    }, [closeAll]);
}
